import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../config/api';
import Captcha from '../components/Captcha';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    ins: '',
    nos: '',
    msg: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });
  const [captchaValid, setCaptchaValid] = useState(false);
  const [captchaReset, setCaptchaReset] = useState(0);

  useEffect(() => {
    // Initialize niceSelect for the contact form selects after component mounts
    const initNiceSelect = () => {
      if (window.jQuery && window.jQuery.fn.niceSelect) {
        const selects = document.querySelectorAll('.contact-form-three select');
        selects.forEach(select => {
          // Destroy existing niceSelect instance if any
          if (window.jQuery(select).data('niceselect')) {
            window.jQuery(select).niceSelect('destroy');
          }
          
          // Add native change event listener BEFORE niceSelect initialization
          const nativeChangeHandler = (e) => {
            const value = e.target.value;
            const name = e.target.name;
            console.log('Native change event:', name, value);
            setFormData(prevData => ({
              ...prevData,
              [name]: value
            }));
          };
          select.addEventListener('change', nativeChangeHandler);
          
          // Initialize niceSelect
          window.jQuery(select).niceSelect();
          
          // Listen for jQuery change events (niceSelect triggers this)
          window.jQuery(select).on('change', function() {
            const selectElement = this;
            const value = selectElement.value;
            const name = selectElement.name;
            console.log('jQuery change event:', name, value);
            
            // Update React state
            setFormData(prevData => ({
              ...prevData,
              [name]: value
            }));
          });
          
          // Also listen for click events on niceSelect options
          const niceSelectContainer = select.nextElementSibling;
          if (niceSelectContainer && niceSelectContainer.classList.contains('nice-select')) {
            const optionClickHandler = (e) => {
              setTimeout(() => {
                const value = select.value;
                const name = select.name;
                console.log('Option clicked, value:', name, value);
                setFormData(prevData => ({
                  ...prevData,
                  [name]: value
                }));
              }, 10);
            };
            niceSelectContainer.addEventListener('click', optionClickHandler);
          }
          
          // Force update to show placeholder
          setTimeout(() => {
            window.jQuery(select).niceSelect('update');
          }, 50);
        });
      }
    };
    
    // Use setTimeout to ensure DOM is fully rendered and React has set the values
    const timer = setTimeout(initNiceSelect, 200);
    return () => clearTimeout(timer);
  }, []);

  // Update niceSelect when form values change (e.g., after reset)
  useEffect(() => {
    if (window.jQuery && window.jQuery.fn.niceSelect) {
      const selects = document.querySelectorAll('.contact-form-three select');
      selects.forEach(select => {
        if (window.jQuery(select).data('niceselect')) {
          window.jQuery(select).niceSelect('update');
        }
      });
    }
  }, [formData.ins, formData.nos]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: newValue
    });
    // Clear status when user starts typing
    if (submitStatus.message) {
      setSubmitStatus({ type: '', message: '' });
    }
    // Update niceSelect after value changes
    setTimeout(() => {
      if (window.jQuery && window.jQuery.fn.niceSelect) {
        window.jQuery(e.target).niceSelect('update');
      }
    }, 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate captcha before submission
    if (!captchaValid) {
      setSubmitStatus({
        type: 'error',
        message: 'Please complete the security verification (captcha) correctly before submitting.'
      });
      return;
    }

    setLoading(true);
    setSubmitStatus({ type: '', message: '' });

    console.log('Submitting form data:', formData);

    // Get actual values from DOM (in case niceSelect didn't update React state)
    const insSelect = document.querySelector('select[name="ins"]');
    const nosSelect = document.querySelector('select[name="nos"]');
    const actualIns = insSelect ? insSelect.value : formData.ins;
    const actualNos = nosSelect ? nosSelect.value : formData.nos;
    
    console.log('Actual select values:', { ins: actualIns, nos: actualNos });

    // Validate required fields including dropdowns
    if (!formData.name || !formData.email || !formData.msg) {
      setSubmitStatus({
        type: 'error',
        message: 'Please fill in all required fields (Name, Email, and Message)'
      });
      setLoading(false);
      return;
    }

    // Validate dropdown fields (check both state and DOM)
    if ((!formData.ins || formData.ins === '') && (!actualIns || actualIns === '')) {
      setSubmitStatus({
        type: 'error',
        message: 'Please select an Industry'
      });
      setLoading(false);
      return;
    }

    if ((!formData.nos || formData.nos === '') && (!actualNos || actualNos === '')) {
      setSubmitStatus({
        type: 'error',
        message: 'Please select Estimated Number of Users'
      });
      setLoading(false);
      return;
    }
    
    // Use actual values from DOM if state values are empty
    const finalFormData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone || null,
      company: formData.company || null,
      ins: actualIns || formData.ins || null,
      nos: actualNos || formData.nos || null,
      msg: formData.msg
    };
    
    console.log('Final form data to submit:', finalFormData);

    try {
      const response = await api.post('/contact', finalFormData);
      const data = response.data;

      console.log('Response status:', response.status);
      console.log('Response data:', data);

      if (data.success) {
        setSubmitStatus({
          type: 'success',
          message: data.message || 'Thank you for your message. We will get back to you soon!'
        });
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          ins: '',
          nos: '',
          msg: ''
        });
        // Reset niceSelect dropdowns
        setTimeout(() => {
          if (window.jQuery && window.jQuery.fn.niceSelect) {
            const selects = document.querySelectorAll('.contact-form-three select');
            selects.forEach(select => {
              window.jQuery(select).niceSelect('update');
            });
          }
        }, 0);
        // Reset captcha
        setCaptchaReset(prev => prev + 1);
      } else {
        const errorMessage = data.message || 
          (data.errors ? Object.values(data.errors).flat().join(', ') : '') ||
          'Server error. Please try again.';
        setSubmitStatus({
          type: 'error',
          message: errorMessage
        });
      }
    } catch (error) {
      console.error('Error submitting contact form:', error);
      const errorMessage = error.response?.data?.message || 
        (error.response?.data?.errors ? Object.values(error.response.data.errors).flat().join(', ') : '') ||
        error.message || 
        'Network error. Please check your connection and try again.';
      setSubmitStatus({
        type: 'error',
        message: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="page-banner bg-blue rel z-1" style={{backgroundImage: 'url(/assets/images/background/banner-bg.png)'}}>
        <div className="container">
          <div className="banner-inner">
            <h1 className="page-title wow fadeInUp delay-0-2s">Contact Us</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active">Contact Us</li>
              </ol>
            </nav>
          </div>
        </div>
        <img className="dots-shape" src="/assets/images/shapes/white-dots-two.png" alt="Shape" />
        <img className="tringle-shape slideLeftRight" src="/assets/images/shapes/white-tringle.png" alt="Shape" />
        <img className="close-shape" src="/assets/images/shapes/white-close.png" alt="Shape" />
        <img src="/assets/images/newsletter/circle.png" alt="shape" className="banner-circle slideUpRight" />
        <img className="dots-shape-three slideUpDown delay-1-5s" src="/assets/images/shapes/white-dots-three.png" alt="Shape" />
      </section>

      <section className="contact-page-section pt-130 rpt-100 pb-150 rpb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="contact-content-area mr-xl-5 rmb-35 wow fadeInLeft delay-0-2s">
                <div className="section-title mb-15">
                  <span className="sub-title">contact us</span>
                  <h2>We're Ready to Help You! Say Hello or Contact Us</h2>
                </div>
                <p>If you're considering digital transformation of your business or automation of certain business operations, or just want more information, we're happy to answer all your questions and get you set up.</p>
                <div className="row pt-25">
                  <div className="col-xl-12 col-lg-12 col-md-6">
                    <div className="contact-info-item style-two">
                      <i className="fas fa-envelope-open"></i>
                      <div className="contact-info-content">
                        <h5>Email Address</h5>
                        <span><a href="mailto:sales@plenitudeit.com.my">sales@plenitudeit.com.my</a></span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-6">
                    <div className="contact-info-item style-two">
                      <i className="fas fa-phone"></i>
                      <div className="contact-info-content">
                        <h5>Phone Number</h5>
                        <span><a href="tel:+60327271889">+603-2727 1889</a></span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-6">
                    <div className="contact-info-item style-two">
                      <i className="fas fa-globe"></i>
                      <div className="contact-info-content">
                        <h5>Website</h5>
                        <span><a href="https://www.plenitudeit.com.my" target="_blank" rel="noopener noreferrer">www.plenitudeit.com.my</a></span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-6">
                    <div className="contact-info-item style-two">
                      <i className="fas fa-map-marker"></i>
                      <div className="contact-info-content">
                        <h5>Location</h5>
                        <span>Level 23, NU Tower 2,<br />
                        Jalan Tun Sambanthan, Kuala Lumpur Sentral,<br />
                        50470, Kuala Lumpur, Malaysia</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-form-area wow fadeInRight delay-0-2s">
                <div className="section-title">
                  <span className="sub-title">Get In Touch</span>
                  <h2>Get Every Single Updates Message us</h2>
                </div>
                <form className="contact-form-three pt-35" onSubmit={handleSubmit}>
                  <div className="row clearfix">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <input 
                          type="text" 
                          id="name" 
                          name="name" 
                          className="form-control" 
                          placeholder="Name" 
                          required 
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input 
                          type="email" 
                          id="email" 
                          name="email" 
                          className="form-control" 
                          placeholder="Email Address" 
                          required 
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input 
                          type="text" 
                          id="phone" 
                          name="phone" 
                          className="form-control" 
                          placeholder="Phone" 
                          required 
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <input 
                          type="text" 
                          id="company" 
                          name="company" 
                          className="form-control" 
                          placeholder="Company" 
                          required 
                          value={formData.company}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <select className="form-control" name="ins" value={formData.ins} onChange={handleChange}>
                          <option value="">Which Industry</option>
                          <option value="Sales and marketing">Sales and marketing</option>
                          <option value="Billing and Payments">Billing and Payments</option>
                          <option value="Operations">Operations</option>
                          <option value="Customer Service">Customer Service</option>
                          <option value="Staff Productivity">Staff Productivity</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <select className="form-control" name="nos" value={formData.nos} onChange={handleChange}>
                          <option value="">Estimate No of use of the system</option>
                          <option value="1-2">1-2</option>
                          <option value="2-5">2-5</option>
                          <option value="5-7">5-7</option>
                          <option value="7-10">7-10</option>
                          <option value="10-100">10-100</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <textarea 
                          name="msg" 
                          id="message" 
                          rows="4" 
                          className="form-control" 
                          placeholder="message" 
                          required 
                          value={formData.msg}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <Captcha 
                        onValidate={setCaptchaValid} 
                        resetTrigger={captchaReset}
                      />
                    </div>
                    <div className="col-md-12">
                      {submitStatus.message && (
                        <div className={`alert ${submitStatus.type === 'success' ? 'alert-success' : 'alert-danger'}`} 
                             style={{ 
                               padding: '12px 20px', 
                               marginBottom: '20px', 
                               borderRadius: '5px',
                               backgroundColor: submitStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                               color: submitStatus.type === 'success' ? '#155724' : '#721c24',
                               border: `1px solid ${submitStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`
                             }}>
                          {submitStatus.message}
                        </div>
                      )}
                      <div className="form-group mb-0">
                        <button 
                          className="theme-btn" 
                          type="submit" 
                          disabled={loading || !captchaValid}
                          style={{ 
                            opacity: (loading || !captchaValid) ? 0.7 : 1, 
                            cursor: (loading || !captchaValid) ? 'not-allowed' : 'pointer' 
                          }}
                        >
                          {loading ? 'Sending...' : 'send message'} 
                          {!loading && <i className="fas fa-arrow-right"></i>}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="contact-page-map mt-80 wow fadeInUp delay-0-2s">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.856572185141!2d101.6841897147573!3d3.132578597718992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc49c056232fa7%3A0x7fdad0874cdd7bf6!2sServcorp%20-%20NU%20Tower%202!5e0!3m2!1sen!2sin!4v1664037791922!5m2!1sen!2sin" 
              width="100%" 
              height="605" 
              style={{border: 0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Location Map"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;

